import validatePhone from "../hooks/validatePhone";

/**
 * Phone validator, validate phone with and without company code
 */
const PhoneValidator = {
    validate() {
        const me = this;
        if (me.phoneCountryData.name == 'OTHER') {
            return validatePhone(me.phone, me.phoneCountryData.regex);
        }
        return me.phoneCountryData.regex.test(me.phone);
    }
};
export default PhoneValidator;
